import { useState } from "react";
import { toast } from "sonner";
import { Flag } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export function ReportButton({ targetType, targetId, label = "Melden", testId = "report-open" }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" className="inline-flex items-center gap-1 text-sm w-muted hover:text-ink underline" onClick={() => setOpen(true)} data-testid={testId}>
        <Flag size={14} aria-hidden="true" /> {label}
      </button>
      {open && <ReportDialog targetType={targetType} targetId={targetId} onClose={() => setOpen(false)} />}
    </>
  );
}

function ReportDialog({ targetType, targetId, onClose }) {
  const [f, setF] = useState({ reason: "", details: "", reporter_email: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/legal/report", { target_type: targetType, target_id: targetId || "", ...f });
      toast.success(`Meldung eingegangen · ${data.case_number}`);
      onClose();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <div className="fixed inset-0 z-50 bg-black/40 grid place-items-center p-4" onClick={onClose} data-testid="report-dialog">
      <form className="w-card p-6 max-w-md w-full space-y-4" onClick={(e) => e.stopPropagation()} onSubmit={submit}>
        <h3 className="font-bold text-lg">Inhalt melden</h3>
        <p className="w-muted text-sm">Melde mutmaßlich rechtswidrige oder missbräuchliche Inhalte, Profile oder Bewertungen. Wir prüfen jede Meldung.</p>
        <label className="block"><span className="w-label">Grund</span>
          <input className="w-input" required minLength={3} value={f.reason} onChange={(e) => setF({ ...f, reason: e.target.value })} data-testid="report-reason" /></label>
        <label className="block"><span className="w-label">Beschreibung (optional)</span>
          <textarea className="w-input !h-24 py-3" value={f.details} onChange={(e) => setF({ ...f, details: e.target.value })} data-testid="report-details" /></label>
        <label className="block"><span className="w-label">Deine E-Mail (optional, für Rückfragen)</span>
          <input className="w-input" type="email" value={f.reporter_email} onChange={(e) => setF({ ...f, reporter_email: e.target.value })} data-testid="report-email" /></label>
        <div className="flex gap-2">
          <button type="button" className="w-btn w-btn-secondary flex-1" onClick={onClose}>Abbrechen</button>
          <button className="w-btn w-btn-primary flex-1" disabled={busy} data-testid="report-submit">{busy ? "Sende…" : "Meldung senden"}</button>
        </div>
      </form>
    </div>
  );
}
